module.exports = __webpack_public_path__ + "img/teeth-17.c08204de.png";